(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.administrationTools = {
        name: 'schoolwork12.administrationTools',
        controllers: {
            administrationTools : 'administrationToolsCtrl',
            withdrawPerson: 'withdrawPersonCtrl',
            fixAdults: 'fixDuplicateAdultsCtrl',
            reactivateAdults: 'reactivateAdultsCtrl'
        },
        routes: {
            administrationTools: '/administration-tools',
            fixAdults: '/fixDuplicateAdults',
            reactivateAdults: '/reactivateAdults'
        },
        templates : {
            administrationTools: 'administrationTools/html/viewAdministrationTools.html',
            fixAdults: 'administrationTools/html/fixDuplicateAdults.html',
            reactivateAdults: 'administrationTools/html/reactivateAdults.html'
        },
        services: {
            administrationToolsSvc: 'administrationToolsSvc', 
            withdrawPersonSvc: 'withdrawPersonSvc'	
        },
        endpoints: {
           administrationToolsEndPoint : schoolwork12.app.endpoint.concat('/datamanagement/'),
           withdrawPersonEndPoint : schoolwork12.app.endpoint.concat('/schools/')
        },
        errorMessages:{
            schoolClusterNameRequired: 'Cluster Name is a required field. Please enter the name for the cluster.',
            schoolClusterAbbreRequired: 'Cluster Abbreviation is a required field. Please enter the abbreviation for the cluster.',
            schoolClusterNameUnique: 'Cluster Name is already used by another cluster.  Please enter an unique Cluster Name.',
            schoolClusterAbbrevUnique: 'Cluster Abbreviation is already used by another cluster.  Please enter an unique Cluster Abbreviation.',
            clusterSchoolDuplicated: 'One or more Schools are already associated to another cluster. Please select a non associated School',
            fixAdultBadPersonIdRequired: 'Bad Person ID is required when fixing duplicate adults. Please enter a value for this field.',
            fixAdultBadPersonIdDoestExist: 'No person was found matching the Bad Person ID. Please review and correct the field.',
            fixAdultGoodPersonIdRequired: 'Good Person ID is required when fixing duplicate adults. Please enter a value for this field.',
            fixAdultGoodPersonIdDoestExist: 'No person was found matching the Good Person ID. Please review and correct the field.',
            fixAdultBadAndGoodPersonEquals: 'Bad Person ID and Good Person ID may not have the same value. Please review and correct the fields.',
            fixAdultBadAndGoodDifferNames: 'Names of the identified persons are different. Please review and correct the fields.',
            fixAdultBadPersonIdInvalid: 'Invalid value for Bad Person Id. Please enter a valid number.',
            fixAdultGoodPersonIdInvalid: 'Invalid value for Good Person Id. Please enter a valid number.',
            reactivateAdultFirstNameRequired: 'First Name is required when reactivating an adult. Please enter a value for this field.',
            reactivateAdultLastNameRequired: 'Last Name is required when reactivating an adult. Please enter a value for this field.',
            reactivateAdultHomePhoneRequired: 'Home Phone is required when reactivating an adult. Please enter a value for this field.',
            reactivateAdultHomePhoneInvalid: 'An invalid value was entered for Home Phone. Please review and correct the value for this field.',
            reactivateAdultDoesntExist: 'No adult was found matching the search criteria. Please review and correct the values of the search fields.',
            reactivateAdultMultiMatch: 'More than one adult was found matching the search criteria. Please review and correct the values of the search fields.',
            reactivateLCNoActiveStudents: 'LC is not active on any active students.'
        }
	};
	
	angular.module(schoolwork12.app.administrationTools.name, []);
     
}(angular, schoolwork12));
